import { useHistory } from 'react-router-dom';
import Button from '../../components/common/buttons/Button';
import GameWrapper from '../../components/common/wrappers/GameWrapper';
import PageWrapper from '../../components/common/wrappers/PageWrapper';

export default function GameCodeNotValidYet() {
    const history = useHistory();

    const onClick = () => {
        history.push({
            pathname: '/',
        });
    };

    return (
        <PageWrapper>
            <div className="error-screen">
                <GameWrapper>
                    <div className="card game-card">
                        <div className="task-title">Chyba</div>
                        <div className="task-text task-text--standalone contact-link">
                            Litujeme, tento přihlašovací kód ještě není v platnosti.
                            <br />
                            Zkuste si prosím kód zkontrolovat a zadejte ho znovu. Pokud se bude problém opakovat,
                            neváhejte nás kontaktovat{' '}
                            <a className="contact-link" href="https://sifrovka.cz/kontakt/">
                                zde
                            </a>
                            {'.'}
                        </div>
                        <div className="home-link">
                            <Button onClick={onClick} className="primary-button">
                                Zadat kód znovu
                            </Button>
                        </div>
                    </div>
                </GameWrapper>
            </div>
        </PageWrapper>
    );
}
